export default __webpack_public_path__ + "static/media/user_paul.9af465b4.png";